import { DsIcon, DsTypography } from '@ice-web-app/designSystem';
import { Box, Fade, Stack } from '@mui/material';
import { FC, ReactElement } from 'react';

interface Props {
  icon: ReactElement | string;
  text: string;
  width: number;
  isActive?: boolean;
  onClick?: () => void;
  nowrap?: boolean;
  isEditMode?: boolean;
  onClickRemoveBtn?: () => void;
}

const QuickLink: FC<Props> = ({ icon, text, width, isActive, isEditMode, nowrap, onClick, onClickRemoveBtn }) => {
  return (
    <Stack
      alignItems="center"
      py={2}
      gap={1}
      width={width}
      sx={{
        ...(isActive && { bgcolor: ({ palette }) => palette.background.default }),
        ...(!isEditMode && {
          ':hover': {
            bgcolor: ({ palette }) => palette.background.default,
          },
          cursor: 'pointer',
        }),
        borderRadius: 'var(--mui-shape-customBorderRadius-lg)',
        position: 'relative',
      }}
      onClick={onClick}
    >
      <Stack
        justifyContent="center"
        alignItems="center"
        sx={{
          border: '1px solid',
          borderColor: ({ palette }) => palette.text.secondary,
          borderRadius: 'var(--mui-shape-customBorderRadius-lg)',
          width: 60,
          height: 60,
        }}
      >
        {icon}
      </Stack>
      <DsTypography
        variant="body2_500"
        sx={{ fontSize: '0.755rem', textAlign: 'center', ...(nowrap && { whiteSpace: 'nowrap' }) }}
      >
        {text}
      </DsTypography>
      <Fade in={isEditMode} timeout={200}>
        <Box
          sx={{
            border: '1px solid',
            borderColor: ({ palette }) => palette.iceGray[500],
            bgcolor: ({ palette }) => palette.iceGray['opacity-16'],
            width: 20,
            height: 20,
            position: 'absolute',
            top: 2,
            left: 10,
            cursor: 'pointer',
            borderRadius: 0.5,
            boxSizing: 'content-box',
          }}
          onClick={onClickRemoveBtn}
        >
          <DsIcon icon="MINUS" size={20} />
        </Box>
      </Fade>
    </Stack>
  );
};
export default QuickLink;
